angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.sellerAddController', ['$q', '$scope', 'virtoCommerce.catalogModule.listEntries', 'virtoCommerce.marketplaceModule.webApi', 'platformWebApp.bladeNavigationService', 'platformWebApp.settings',
        function ($q, $scope, listEntries, marketplaceApi, bladeNavigationService, settings) {
            var blade = $scope.blade;
            blade.isLoading = true;
            blade.command = {
                ownerDetails: { }
            };

            blade.refresh = function () {
                marketplaceApi.getSettings((settings) => {
                    listEntries.listitemssearch(
                        {
                            catalogId: settings.masterCatalogId,
                            objectTypes: ['Category'],
                            searchInChildren: true,
                            sort: 'path:desc',
                            skip: 0,
                            take: 1000
                        },
                        function (data) {
                            blade.categories = data.listEntries;
                            blade.categories.forEach(category => category.path = category.path.join(' / '));

                            marketplaceApi.searchFees({ type: 'static', skip: 0, take: 1000 }, function (data) {
                                blade.staticFees = data.results ? data.results : [];

                                var commissionFee = blade.staticFees.find(staticFee => staticFee.isDefault);
                                if (commissionFee) {
                                    blade.command.commissionFeeId = commissionFee.id;
                                }

                                blade.isLoading = false;
                            });
                        });
                });
            };

            blade.openStaticCommissions = function () {
                var newBlade = {
                    id: 'fees-static',
                    title: 'marketplace.blades.fee-static-list.title',
                    controller: 'virtoCommerce.marketplaceModule.feeStaticListController',
                    template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/fee-static-list.tpl.html',
                    sortDefault: true,
                    onClose: function (closeCallback) {
                        marketplaceApi.searchFees({ type: 'static', skip: 0, take: 1000 }, function (data) {
                            blade.staticFees = data.results ? data.results : [];
                        });
                        closeCallback();
                    }
                };
                bladeNavigationService.showBlade(newBlade, $scope.blade);
            };

            blade.groups = settings.getValues({ id: 'Customer.MemberGroups' });

            $scope.saveChanges = function () {
                blade.isLoading = true;
                marketplaceApi.createSeller(blade.command, function () {
                    $scope.bladeClose();
                    blade.parentBlade.refresh();
                });
            }

            $scope.validateEmailAsync = function(value) {
                return marketplaceApi.validateSellerUser({
                     sellerUser: { email: value }
                }).$promise.then(result => {
                    if (!_.any(result, error => error.propertyName === 'Email')) {
                        $scope.errorData = null;
                        return $q.resolve();
                    } else {
                        $scope.errorData = _.filter(result, error => error.propertyName === 'Email')[0];
                        return $q.reject();
                    }
                });
            };

            $scope.setForm = function (form) { $scope.formScope = form; };

            blade.refresh();
        }
]);
